import React from 'react'
import {useState, useEffect} from 'react'
import ProjectTile from '../components/content/ProjectTile'
import '../styles/App.css'
import config from '../config.json'

function Projects() {

  const [projects, setProjects] = useState([])
  const [categories, setCategories] = useState([])

  useEffect(() => {
    Promise.all([
      fetch(config.api_url + "/getAllProjects").then(value => value.json()),
      fetch(config.api_url + "/getAllCategories").then(value => value.json())
    ]).then(([projects, categories]) => {
      setProjects(projects)
      setCategories(categories)
    }).catch((err) => {
      console.log(err)
    });
  }, [])

  return (
    <div className='container container-page container-column'>
      {categories.map((category) => {
        return (
          <div key={category.title}>
            <h2 className="project-category">{category.title}</h2>
            <div className='project-gallery'>
              {projects.filter((p) => {return p.category_id===category.id}).map((project) => {
                return (
                  <ProjectTile
                    categoryTitle={category.title}
                    project={project}
                  />
                )
              })}
            </div>
          </div>
        )
      })}
    </div>
  );
}

export default Projects
